import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AuthCallBack() {
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.substring(1));
    const access_token = params.get('access_token');
    const refresh_token = params.get('refresh_token');
    const type = params.get('type');
    window.history.replaceState(null, '', window.location.pathname);
    if (access_token && refresh_token && ['invite', 'recovery'].includes(type)) {
      navigate('/set-password', { replace: true, state: { access_token, refresh_token } });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);
  return <div>Finalizing authentication...</div>;
}
